import { ThemeMode } from "./types";

const THEME_KEY = "chpy-web-theme";

export const getStorageTheme = () =>
  typeof window !== "undefined" ? localStorage.getItem(THEME_KEY) as ThemeMode : "window98";

export const setStorageTheme = (themeValue: ThemeMode) =>
  typeof window !== "undefined" && localStorage.setItem(THEME_KEY, themeValue);
